import { Decimal } from 'decimal.js';
import { formatDollarAmount } from '../../../../../utils/number-formatting';
const isRange = (value)=>typeof value === 'object' && value !== null && value.to instanceof Decimal;
const isDiscounted = (value)=>typeof value === 'object' && value !== null && 'charged' in value && 'beforeDiscount' in value;
const amountText = (value, openRangeText)=>{
    if (value instanceof Decimal) return formatDollarAmount(value);
    if (!isRange(value)) return undefined;
    const max = formatDollarAmount(value.to);
    if (value.from != null) return "".concat(formatDollarAmount(value.from), " - ").concat(max);
    return openRangeText == null ? max : openRangeText(max);
};
export const moneyParts = (value, openRangeText)=>{
    if (isDiscounted(value)) {
        const charged = amountText(value.charged, openRangeText);
        const beforeDiscount = amountText(value.beforeDiscount, openRangeText);
        return charged == null ? undefined : {
            charged,
            beforeDiscount
        };
    }
    const charged = amountText(value, openRangeText);
    return charged == null ? undefined : {
        charged
    };
};
